import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle, AlertCircle, XCircle } from 'lucide-react';
import { formatDuration } from '../utils/formatDuration';
import { confidencePercent, confidenceLevel } from '../utils/confidence';
import './ConfidenceScore.css';

const LEVEL_META = {
  high: { labelKey: 'confidence.high', icon: CheckCircle },
  medium: { labelKey: 'confidence.medium', icon: AlertCircle },
  low: { labelKey: 'confidence.low', icon: XCircle },
};

function ConfidenceScore({ score, iterations, duration }) {
  const { t } = useTranslation('components');
  const percentage = confidencePercent(score);
  const level = confidenceLevel(percentage);
  const { labelKey, icon: Icon } = LEVEL_META[level];
  const label = t(labelKey);

  return (
    <div className={`confidence-score ${level}`}>
      <div className="score-header">
        <Icon size={20} />
        <span className="score-label">{label}</span>
      </div>

      <div className="score-value">
        <div className="score-circle">
          <svg viewBox="0 0 36 36">
            <path
              className="circle-bg"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle-progress"
              strokeDasharray={`${percentage}, 100`}
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <span className="score-number">{percentage}%</span>
        </div>
      </div>

      <div className="score-details">
        {iterations && (
          <div className="detail-item">
            <span className="detail-label">{t('confidence.iterations')}</span>
            <span className="detail-value">{iterations}</span>
          </div>
        )}
        {duration > 0 && (
          <div className="detail-item">
            <span className="detail-label">{t('confidence.duration')}</span>
            <span className="detail-value">{formatDuration(duration)}</span>
          </div>
        )}
      </div>

      <div className="score-description">
        {percentage >= 85 && (
          <p>{t('confidence.descriptions.high')}</p>
        )}
        {percentage >= 65 && percentage < 85 && (
          <p>{t('confidence.descriptions.medium')}</p>
        )}
        {percentage < 65 && (
          <p>{t('confidence.descriptions.low')}</p>
        )}
      </div>
    </div>
  );
}

export default ConfidenceScore;
